import React from 'react';
import {COLORS} from '@fupa/fupa-uikit';
import {CenteredTypography, Section} from './CardStyles';
import {styled} from '@mui/material/styles';

const SCSection = styled(Section)`
  &&& {
    padding-top: 0;
  }
`;

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 90%;
`;

const Container = styled('div')`
  display: flex;
  justify-content: center;
`;

const VideoWrapper = styled('div')`
  width: 100%;
  max-width: 560px;
  max-height: 315px;
  height: calc(100vw * 9 / 16);
  aspect-ratio: 16/9;
`;

const PromoVideoCard = () => {
  return (
    <SCSection backgroundColor={COLORS.lightGrey}>
      <Wrapper>
        <CenteredTypography variant='headline2' component='h2'>
          Konzentriere dich auf das Wesentliche: Deinen Verein
        </CenteredTypography>
        <CenteredTypography variant='subheading' component='p'>
          Die Pflege eurer Vereinswebsite macht viel Arbeit? <br />
          Die neuen FuPa Widgets müssen nur ein einziges Mal eingebunden werden, und funktionieren saisonübergreifend!
          <br />
          Und das Beste: Schriften, Farben, Layouts: alles kann individuell angepasst werden!
        </CenteredTypography>
        <Container>
          <VideoWrapper>
            <iframe
              width='100%'
              height='100%'
              style={{border: 'none'}}
              src='https://www.youtube-nocookie.com/embed/0XyI0aYV3O0?si=j_N_O8gZxlE1F86E'
              title='YouTube video player'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              allowFullScreen={true}></iframe>
          </VideoWrapper>
        </Container>
      </Wrapper>
    </SCSection>
  );
};

export default PromoVideoCard;
